import { render } from "./PortfolioSimulator.vue?vue&type=template&id=135b72c3&scoped=true"
import script from "./PortfolioSimulator.vue?vue&type=script&lang=js"
export * from "./PortfolioSimulator.vue?vue&type=script&lang=js"

import "./PortfolioSimulator.vue?vue&type=style&index=0&id=135b72c3&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-135b72c3"]])

export default __exports__